import React from 'react'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import FieldModal from '..'

import { formatForUpload } from '../helpers'
import { createCustomFields } from '@SonarCX/slices/customFields'
import { AddSuccessAlert } from '@SonarCX/slices/alert'

type NewFieldModalProps = {
  objectType: APICustomField['object_type']
  onClose: () => void
}

const INITIAL_VALUES = (
  object_type: APICustomField['object_type']
): APICustomField => ({
  id: null,
  object_type,
  title: '',
  description: '',
  field_type: 'text',
  config: { id: '', options: [] },
  created_by: '',
  archived_at: '',
  created_at: '',
  updated_at: ''
})

const NewFieldModal: React.FC<NewFieldModalProps> = ({
  objectType,
  onClose,
  ...props
}) => {
  const dispatch = useAppDispatch()

  const field = React.useMemo(() => INITIAL_VALUES(objectType), [objectType])

  const handleSave = React.useCallback(
    (field: APICustomField) => {
      dispatch(
        createCustomFields([formatForUpload(field)], () => {
          dispatch(AddSuccessAlert('Changes saved'))
          onClose()
        })
      )
    },
    [dispatch, onClose]
  )

  return (
    <FieldModal
      field={field}
      onClose={onClose}
      onSave={handleSave}
      {...props}
    />
  )
}

export default NewFieldModal
